import {
  REPORT_FREQUENCY_DAILY,
  REPORT_FREQUENCY_MONTHLY,
  REPORT_FREQUENCY_WEEKLY,
} from 'constants/reportFrequency';

const defaultReportSettings = {
  monthday: 1,
  weekday: 1,
  hour: 9,
  minute: '00',
  timezone: 'US/Arizona',
};

export default {
  reportSettings: {
    [REPORT_FREQUENCY_DAILY]: defaultReportSettings,
    [REPORT_FREQUENCY_MONTHLY]: defaultReportSettings,
    [REPORT_FREQUENCY_WEEKLY]: defaultReportSettings,
  },
  updateFrequency: 'none',
  repeatDuration: 'once',
  updateEmails: [],
  repeatMessage: 'Thanks for taking our survey!',
  blockedMessage: 'This survey is not available from your location.',
  accessDefault: 'deny',
  accessBlockIp: [],
  accessAllowIp: [],
  reCaptchaEnabled: false,
  maxResponses: 0,
  maxResponsesPartial: true,
  cutOffDate: {
    dateTime: null,
    timezone: 'US/Eastern',
  },
  postLogicQuestionsCount: 0,
  sendWithoutUpdates: false,
  isBackButtonEnabled: true,
  questionNumberingEnabled: true,
};
